import React from "react"

export const StandardContentBanner = () => {
    return (
        <style>
            {`
          :root {
            --next-header-height: calc(7.75rem + var(--next-header-branchio-height, 0px)));
          }
        `}
        </style>
    )
}
export default StandardContentBanner
